import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	Text,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

// eslint-disable-next-line arrow-body-style
const BigLeapContext = () => {
	return (
		<>
			{/* members */}
			<Flex
				as="section"
				flexDirection="column"
				overflow="hidden"
				justify="center"
				height={{ xs: "450px", sm: "300px" }}
				minH={{ xs: "450px", sm: "300px" }}
				maxH="450px"
				pos="relative"
			>
				<Img
					pos="absolute"
					objectFit="cover"
					src="/jpg/blogBanner.jpg"
					alt="members-hero"
					height="100%"
					width="100%"
				/>
				<Box
					bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
					pos="absolute"
					height="100%"
					width="100%"
					opacity="0.7"
				/>
				<Container
					display="flex"
					as="section"
					maxW="container.xl"
					position="relative"
					zIndex="1"
					flexDirection="column"
				>
					<Flex
						alignItems={{ xs: "flex-start", md: "flex-start" }}
						justifyContent="center"
						columnGap="24px"
						justifyItems="center"
						width="100%"
						display="flex"
						as="section"
						rowGap="30px"
						flexDir={{
							xs: "column",
							md: "row",
						}}
					>
						<Flex flexDir="column" rowGap="16px">
							<Heading
								color="white"
								fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
								fontWeight="800"
								lineHeight={{ xs: "35px", lg: "83px" }}
							>
								#TheContext
							</Heading>
						</Flex>
						<Box
							w="1.5px"
							h={{ xs: "100%" }}
							bgColor="white"
							display={{ xs: "none", md: "block" }}
						/>
						<Box
							w={{ xs: "70%", sm: "60%" }}
							h="1.5px"
							bgColor="white"
							display={{ xs: "block", md: "none" }}
						/>
						{/*  */}
						<Heading
							as="h1"
							mb={{ xs: "10px", md: "20px" }}
							variant="reportCardTitle"
							fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
							color="white"
							lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
						>
							#AltCap101: IVCA’s Next Big Leap for India’s Private Equity
							Leaders
						</Heading>
					</Flex>
				</Container>
			</Flex>
			<Container
				as="section"
				maxW="container.xl"
				pb="80px"
				pt="40px"
				minH="420px"
				display={{ xs: "flex", md: "inherit" }}
				flexDirection="column"
			>
				<Box
					float={{ xs: "right", md: "left" }}
					alignSelf={{ xs: "center", md: "flex-start" }}
					mx={{ xs: "0px", md: "0px" }}
					mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
					mb="20px"
				>
					<Flex
						flexDir={{
							xs: "column",
							md: "row",
						}}
						gap="20px"
						alignItems={{
							xs: "center",
							md: "unset",
						}}
					>
						<Img
							src="https://static.levocdn.com/WGLBUT82/AmitPandey-eg6VhlkQ16xS6.jpeg"
							alt="Amit Pandey"
							width="250px"
							height="250px"
							objectFit="cover"
							borderRadius="50%"
						/>
						<Flex direction="column">
							<Heading
								as="h1"
								fontWeight="800"
								pt="20px"
								variant="reportCardTitle"
								fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
								textAlign={{
									xs: "center",
									md: "left",
								}}
							>
								Amit Pandey
								<Link
									href="https://www.linkedin.com/in/amitpandey2012"
									target="_blank"
									display={{ xs: "inline-block", md: "none" }}
									pl="10px"
								>
									<IconButton
										aria-label="linkedin"
										icon={<FaLinkedin size="28px" color="#067acc" />}
										variant="unstyled"
										cursor="pointer"
									/>
								</Link>
							</Heading>
							<Text
								color="text.mediumBlack"
								maxW={{
									xs: "100%",
									md: "120px",
								}}
								w="100%"
								fontSize="16px"
								lineHeight="22px"
								fontStyle="italic"
								textAlign={{
									xs: "center",
									md: "left",
								}}
							>
								Lead – VC Ecosystem & Capacity Building, IVCA
							</Text>

							<Link
								href="https://www.linkedin.com/in/amitpandey2012"
								target="_blank"
								display={{
									xs: "none",
									md: "block",
								}}
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Flex>
					</Flex>
				</Box>
				<Box>
					<Box mt="16px" mb="20px">
						<Text variant="blogAnswer">
							After the phenomenal success of IVCA&apos;s #VC101 in 2023, which
							focused on empowering first-time fund managers, we are back with
							an even bigger initiative—#AltCap101. This program, organized in
							collaboration with IC Universal Legal (ICUL) and EY India, is the
							next step in IVCA&apos;s mission to provide unparalleled insights
							and training for senior partners in the alternate capital
							ecosystem (PE/VC, AIFs and others). Last year’s #VC101 set the bar
							high, achieving a stellar Net Promoter Score (NPS) of 62, and now
							we aim to scale even greater heights with #AltCap101.
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							The alternative capital industry in India has experienced a
							remarkable transformation over the past few quarters, with private
							capital assets under management (AUM) more than tripling to $124.3
							billion by the end of 2023. Recognizing this growth, #AltCap101 is
							designed to equip experienced fund managers with the tools and
							knowledge they need to navigate the rapidly evolving landscape.
							This full-day program focuses on critical areas like governance
							best practices, regulatory frameworks, and emerging trends,
							offering attendees a comprehensive understanding of the
							industry&apos;s future direction.
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							What Makes AltCap101 Essential for Senior Partners?
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							#AltCap101 is not just another program—it’s a strategic initiative
							aimed at addressing the unique needs of senior partners in the
							alternative investment space. Over the course of the day,
							participants will dive deep into real-world case studies, engage
							in interactive sessions, and receive data-driven insights from
							some of the most influential minds in the industry. With content
							curated specifically for experienced professionals, the agenda
							will cover everything from fund formation to the latest industry
							innovations. Attendees can expect to walk away with actionable
							strategies and practical tools that will enhance their fund’s
							performance.
							<br />
							<br />
							The program agenda includes sessions on regulatory trends,
							governance best practices, and new investment opportunities in
							India. Key topics like ESG compliance, cross-border investments,
							and fund governance will be discussed in detail, offering
							participants a 360-degree view of the challenges and opportunities
							in today’s market. Additionally, the program will feature industry
							leaders who are shaping the future of alternate capital
							investments in India.
						</Text>
					</Box>
					<Box mt="32px">
						<Text variant="blogAnswer" fontWeight="800">
							Why EY and ICUL?
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							EY and ICUL are the perfect partners for #AltCap101. As one of the
							world’s leading professional services organizations, EY brings a
							wealth of expertise in data analytics, regulatory compliance, and
							industry best practices. ICUL, with its in-depth legal knowledge
							and industry experience, complements this by offering cutting-edge
							insights into fund structuring, governance, and regulatory
							frameworks. Together, they ensure that participants receive a
							well-rounded and high-impact learning experience.
						</Text>
					</Box>
					<Box mt="32px">
						<Text variant="blogAnswer" fontWeight="800">
							Register Now and Elevate Your Fund’s Performance
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							Don’t miss out on this opportunity to be part of India’s most
							exclusive forum for senior partners in the alternative investment
							space. The “Phase I” of registrations saw over 50 applications,
							with 20 seasoned professionals already shortlisted. Starting
							October 1st, Phase II applications will open to both IVCA members
							and non-members, offering a 50% discount on applicable rates. Join
							#AltCap101 to gain experiential learning, expand your network, and
							develop an action plan tailored to your firm’s long-term goals.
							Secure your spot today and take the next step toward ensuring your
							fund stays ahead in the competitive alternate capital (PE/VC, AIFs
							and others) landscape.
						</Text>
					</Box>

					<Box my="16px">
						<Text variant="blogAnswer">
							For more information and to register, visit
							<Link
								href="https://www.ivca.in/altcap-101"
								target="_blank"
								fontWeight="700"
								ml="4px"
								style={{ color: "blue", textDecoration: "underline" }}
							>
								https://www.ivca.in/altcap-101
							</Link>
						</Text>
					</Box>
				</Box>

				<Box width="100%" height="2px" bgColor="primary.200" />
				<Text
					variant="blogAnswer"
					lineHeight="30px"
					pt="18px"
					fontStyle="italic"
					p="12px 12px 0px"
					fontWeight="500"
				>
					<Text as="span" fontWeight="700" fontStyle="normal">
						#TheContext by IVCA
					</Text>{" "}
					– features opinion makers from the alternate investing industry with
					strong focus on India as an investment destination. Watch this space
					for new announcements in the sector, viewpoints on investment themes,
					emerging trends, economic reports, analysis and latest industry
					insights.
				</Text>
				<Heading
					variant="blogQuestion"
					lineHeight="30px"
					pt="16px"
					fontStyle="italic"
					p="12px 12px 0px"
				>
					Content in this section is curated by team IVCA. To share feedback,
					connect with&nbsp;
					{/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
					<Link
						href="mailto:paromita.sinha@ivca.in"
						target="_blank"
						style={{ color: "blue", textDecoration: "underline" }}
					>
						paromita.sinha@ivca.in
					</Link>
				</Heading>
			</Container>
		</>
	);
};

export default BigLeapContext;
